export const DAYS_PER_YEAR = 365;
export const SECONDS_PER_DAY = 60 * 60 * 24;
